import { Box, Typography } from '@mui/material'
import { Visibility, Pause, PlayArrow } from '@mui/icons-material'
import { useNavigate } from 'react-router'
import { useRef, useState } from 'react'

const PRIDE = ['#E40303', '#FF8C00', '#FFED00', '#008026', '#24408E', '#732982']

const TEXT_GRADIENTS = [
    'linear-gradient(135deg, #E40303 0%, #FF8C00 100%)',
    'linear-gradient(135deg, #FF8C00 0%, #FFED00 100%)',
    'linear-gradient(135deg, #008026 0%, #24408E 100%)',
    'linear-gradient(135deg, #24408E 0%, #732982 100%)',
    'linear-gradient(135deg, #732982 0%, #E40303 100%)',
    'linear-gradient(135deg, #24408E 0%, #008026 100%)',
]

const pickGradient = (id) => {
    const sum = String(id).split('').reduce((a, c) => a + c.charCodeAt(0), 0)
    return TEXT_GRADIENTS[sum % TEXT_GRADIENTS.length]
}

export const colors = PRIDE

export const MediaCard = ({ item }) => {
    const navigate = useNavigate()
    const videoRef = useRef(null)
    const [isPlaying, setIsPlaying] = useState(true)

    if (!item?.img) return null

    const isVideo = item.img.includes('mp4')
    const isHostedImg = item.img.startsWith('http') && !item.img.startsWith('<')
    const isText = !isVideo && !isHostedImg

    const togglePlay = (e) => {
        e.stopPropagation()
        const el = videoRef.current
        if (!el) return
        if (el.paused) { el.play(); setIsPlaying(true) }
        else { el.pause(); setIsPlaying(false) }
    }

    return (
        <Box
            onClick={() => item?.id && navigate('/post/' + item.id)}
            sx={{
                position: 'relative',
                borderRadius: 2,
                overflow: 'hidden',
                cursor: 'pointer',
                background: isText ? pickGradient(item.id) : '#111',
                minHeight: isText ? 120 : 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '&:hover .hover-overlay': { opacity: 1 },
            }}
        >
            {isVideo && (
                <video
                    ref={videoRef}
                    style={{ width: '100%', display: 'block' }}
                    autoPlay
                    muted
                    loop
                    playsInline
                    onClick={togglePlay}
                    onPlay={() => setIsPlaying(true)}
                    onPause={() => setIsPlaying(false)}
                >
                    <source src={item.img} type="video/mp4" />
                </video>
            )}

            {isVideo && (
                <Box
                    onClick={togglePlay}
                    sx={{
                        position: 'absolute',
                        bottom: 8,
                        right: 8,
                        width: 30,
                        height: 30,
                        borderRadius: '50%',
                        bgcolor: 'rgba(0,0,0,0.5)',
                        backdropFilter: 'blur(6px)',
                        color: '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'background 0.15s ease',
                        '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' },
                    }}
                >
                    {isPlaying ? <Pause sx={{ fontSize: 16 }} /> : <PlayArrow sx={{ fontSize: 16 }} />}
                </Box>
            )}

            {!isVideo && isHostedImg && (
                <img
                    src={item.img}
                    alt=""
                    loading="lazy"
                    style={{ width: '100%', display: 'block', objectFit: 'cover' }}
                    onError={(e) => { e.target.style.display = 'none' }}
                />
            )}

            {isText && (
                <Typography
                    sx={{
                        color: '#fff',
                        fontSize: 12,
                        fontWeight: 600,
                        p: 1.5,
                        lineHeight: 1.5,
                        textShadow: '0 1px 3px rgba(0,0,0,0.4)',
                    }}
                >
                    {item.img.replace(/(<([^>]+)>)/gi, '').replaceAll('&#39;', "'").slice(0, 80)}
                    {item.img.length > 80 ? '…' : ''}
                </Typography>
            )}

            <Box
                className="hover-overlay"
                sx={{
                    position: 'absolute',
                    inset: 0,
                    background: 'rgba(0,0,0,0.45)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    opacity: 0,
                    transition: 'opacity 0.2s ease',
                }}
            >
                <Visibility sx={{ color: '#fff', fontSize: 28 }} />
            </Box>
        </Box>
    )
}
